import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/aiservices'

const CreateAppModal = ({ handleRefresh, assistantId }) => {
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  console.log('assistantIdAppModal', assistantId)

  // console.log(svgIcon, "svgIcon")
  const handleModal = () => {
    setOpenAddProduct(true)
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    const newEntry = {
      appId: e.target.appId.value,
      name: e.target.appName.value,
      description: e.target.appDescription.value,
    }

    // Check if document exists
    const { response: existingDoc } = await AppService.app_agent.getAll({
      query: `assistantId=${assistantId}`,
    })

    let res
    if (existingDoc?.data?.length) {
      // Update (push new data into array)
      const updatedPayload = {
        assistantId: assistantId,
        applications: [...existingDoc.data, newEntry],
      }

      res = await AppService.app_agent.update({
        payload: updatedPayload,
      })
    } else {
      // Create new document
      const payload = {
        assistantId: assistantId,
        applications: [newEntry],
      }

      res = await AppService.app_agent.create({ payload })
    }

    setProcessing(false)
    closeAddProduct()
    handleRefresh()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Add App Agent
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create App Agent
            </MDTypography>
            <MDBox mb={2}>
              <MDTypography variant="button">App ID</MDTypography>
              <MDInput label="App ID" name="appId" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="appName" name="appName" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Description</MDTypography>
              <MDInput
                label="Description"
                name="appDescription"
                fullWidth
                required
                multiline
                rows={4} // You can change this to however many rows you want
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateAppModal
